import axios from "axios"

/* register */
const register = async (userData) => {
  const { data } = await axios.post(
    `${process.env.REACT_APP_URL}/user/signup`,
    userData
  )
  if (data) {
    localStorage.setItem("user", JSON.stringify(data))
  }
  return data
}

/* login */
const login = async (userData) => {
  const { data } = await axios.post(
    `${process.env.REACT_APP_URL}/user/signin`,
    userData
  )
  if (data) {
    localStorage.setItem("user", JSON.stringify(data))
  }
  return data
}

/* logout */
const logout = () => {
  localStorage.removeItem("user")
}

const authService = { login, logout, register }
export default authService
